import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import React, { FC, useMemo } from 'react';
import { Image } from '../../../components/Image';
import dayjs from 'dayjs';
import { STYLE_VARS } from '../../../constants/style-vars';
import { Button } from '../../../components/Button';
import { NavigationService } from '../../../services/navigation';
import { useIsDesktop } from '../../../hooks/useIsDeskTop';
import { COLORS, FONTS } from '../../../constants';
import { IEvent } from '../../../types';
import { convertUnixToUTCDate } from '../../../services/utils/dateConvert';

interface EventItemProps {
  item: IEvent;
  type: 'Grid' | 'List';
  haveBottomLine?: boolean;
}

const EventItem: FC<EventItemProps> = ({
  item,
  type,
  haveBottomLine = true,
}) => {
  const isDesktop = useIsDesktop();
  const styles = StyleSheet.create({
    wrapper: {
      paddingVertical: 20,
    },
    bottomLine: {
      borderBottomColor: COLORS.DARK_GREY,
      borderBottomWidth: 1,
    },
    title: {
      fontFamily: FONTS.AvenirMedium,
      fontSize: 18,
      fontWeight: '500',
      color: COLORS.GREEN,
      textTransform: 'uppercase',
    },
    dayText: {
      fontFamily: FONTS.AvenirMedium,
      fontSize: 13,
      fontWeight: '500',
      color: COLORS.DARKER_GREY,
      textTransform: 'uppercase',
    },
    horizontalLine: {
      width: 30,
      height: 3,
      backgroundColor: COLORS.GREEN,
    },
  });

  const renderContent = useMemo(() => {
    if (type === 'Grid') {
      if (item.thumb) {
        return (
          <View
            style={[
              styles.wrapper,
              isDesktop() && { flexDirection: 'row' },
              haveBottomLine && styles.bottomLine,
            ]}
          >
            <View style={isDesktop() && { width: '40%' }}>
              <View
                style={{
                  paddingHorizontal: isDesktop() ? 10 : 0,
                  marginTop: isDesktop() ? 10 : 0,
                }}
              >
                <TouchableOpacity
                  onPress={() => {
                    NavigationService.push<'Root'>('Root', {
                      screen: 'MenuTab',
                      params: {
                        screen: 'EventDetail',
                        params: {
                          id: item.id,
                        },
                      },
                    });
                  }}
                >
                  <Image
                    source={{ uri: item.thumb }}
                    style={{
                      width: '100%',
                      height: 170,
                      resizeMode: 'cover',
                      marginBottom: 5,
                    }}
                  />
                </TouchableOpacity>
              </View>
            </View>
            <View style={{ flex: 1 }}>
              <View style={{ paddingVertical: 10 }}>
                <TouchableOpacity
                  onPress={() => {
                    NavigationService.push<'Root'>('Root', {
                      screen: 'MenuTab',
                      params: {
                        screen: 'EventDetail',
                        params: {
                          id: item.id,
                        },
                      },
                    });
                  }}
                >
                  <Text style={styles.title} numberOfLines={3}>
                    {item.title}
                  </Text>
                </TouchableOpacity>
              </View>
              <View style={styles.horizontalLine} />
              <View style={{ paddingVertical: 10 }}>
                <Text style={styles.dayText}>
                  {convertUnixToUTCDate(item.start).format('DD-MM-YYYY')}
                  <Text style={{ paddingHorizontal: 5 }}>-</Text>
                  {convertUnixToUTCDate(item.end).format('DD-MM-YYYY')}
                </Text>
              </View>
              <View
                style={{
                  flexDirection: 'row',
                  alignSelf: 'flex-start',
                  alignItems: 'center',
                  marginBottom: 10,
                }}
              >
                <View style={{ marginRight: 8 }}>
                  <Button
                    text="READ MORE"
                    style={STYLE_VARS.blueButton}
                    onPress={() => {
                      NavigationService.push<'Root'>('Root', {
                        screen: 'MenuTab',
                        params: {
                          screen: 'EventDetail',
                          params: {
                            id: item.id,
                          },
                        },
                      });
                    }}
                  />
                </View>
                {isDesktop() && (
                  <>
                    <View style={{ marginRight: 8 }}>
                      <Button
                        text="SIGN UP"
                        style={STYLE_VARS.blueButton}
                        onPress={() => {}}
                      />
                    </View>
                  </>
                )}
              </View>
            </View>
            <View
              style={{
                width: 60,
                height: 60,
                backgroundColor: STYLE_VARS.kccRed,
                position: 'absolute',
                borderRadius: 30,
                alignItems: 'center',
                justifyContent: 'center',
                top: isDesktop() ? 10 : 0,
                left: isDesktop() ? 0 : -10,
              }}
            >
              <View style={{ flexDirection: 'row' }}>
                <Text
                  style={{
                    fontSize: 13,
                    color: 'white',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                  }}
                >
                  {convertUnixToUTCDate(item.start).format('MMM DD')}
                </Text>
              </View>
            </View>
          </View>
        );
      }
    } else {
      return (
        <View
          style={[
            styles.wrapper,
            haveBottomLine && styles.bottomLine,
            isDesktop() && { paddingEnd: 110 },
          ]}
        >
          <View style={{ paddingVertical: 10 }}>
            <TouchableOpacity
              onPress={() => {
                NavigationService.push<'Root'>('Root', {
                  screen: 'MenuTab',
                  params: {
                    screen: 'EventDetail',
                    params: {
                      id: item.id,
                    },
                  },
                });
              }}
            >
              <Text style={styles.title} numberOfLines={1}>
                {item.title}
              </Text>
            </TouchableOpacity>
          </View>
          <View style={styles.horizontalLine} />
          <View style={{ paddingVertical: 10 }}>
            <Text style={styles.dayText}>
              {convertUnixToUTCDate(item.start).format('DD-MM-YYYY')}
              <Text style={{ paddingHorizontal: 5 }}>-</Text>
              {convertUnixToUTCDate(item.end).format('DD-MM-YYYY')}
            </Text>
          </View>
          <View
            style={{
              flexDirection: 'row',
              alignSelf: 'flex-start',
              alignItems: 'center',
              marginBottom: 10,
            }}
          >
            <View style={{ marginRight: 8 }}>
              <Button
                text="READ MORE"
                style={STYLE_VARS.blueButton}
                onPress={() => {
                  NavigationService.push<'Root'>('Root', {
                    screen: 'MenuTab',
                    params: {
                      screen: 'EventDetail',
                      params: {
                        id: item.id,
                      },
                    },
                  });
                }}
              />
            </View>
            {isDesktop() && (
              <>
                <View style={{ marginRight: 8 }}>
                  <Button
                    text="SIGN UP"
                    style={STYLE_VARS.blueButton}
                    onPress={() => {}}
                  />
                </View>
              </>
            )}
          </View>
        </View>
      );
    }
  }, [type, item, styles, isDesktop, haveBottomLine]);

  return <View style={{ marginBottom: 10 }}>{renderContent}</View>;
};

export default EventItem;
